import {useQuery} from "@apollo/client";
import {createContext, PropsWithChildren, useState} from "react";

import {CheckoutContextResult, GQL_CHECKOUT_CONTEXT} from "@/lib/queries/billing.ts";
import {BillingData, PaymentMethod} from "@/lib/types/billing.ts";

export interface CheckoutContext {
  braintreeToken?: string;
  recaptchaSiteKey?: string;
  hasActiveSubscription?: boolean;
  isSubscriptionPastDue?: boolean;
  hasActivePremiumFeatures?: boolean;
  billingData?: BillingData;
  paymentMethod?: PaymentMethod;
  requestInProgress: boolean;
  setRequestInProgress: (value: boolean) => void;
  billingAmount?: number;
  nextBillingDate?: Date;
}

const DEFAULT_VALUE: CheckoutContext = {
  paymentMethod: {},
  billingData: {},
  hasActiveSubscription: false,
  isSubscriptionPastDue: false,
  hasActivePremiumFeatures: false,
  requestInProgress: false,
  setRequestInProgress: () => {},
};

export const CheckoutContext = createContext<CheckoutContext>(DEFAULT_VALUE);

export const CheckoutContextProvider = ({children}: PropsWithChildren) => {
  const {data} = useQuery<CheckoutContextResult>(GQL_CHECKOUT_CONTEXT);

  const [requestInProgress, setRequestInProgress] = useState(false);
  return (
    <CheckoutContext.Provider value={{requestInProgress, setRequestInProgress, ...data?.checkoutContext}}>
      {children}
    </CheckoutContext.Provider>
  );
};
